import CommonDelete from "@/components/CommonUi/CommonDelete";
import CreateDrawer from "@/components/CommonUi/CreateDrawer";
import TableComponent from "@/components/CommonUi/TableComponent";
import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { useGetCampaignCodesPaginatedQuery } from "@/redux/rtk/features/campaignCode/campaignCodeApi";

import Modal from "@/UI/Modal";
import { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { useTranslation } from "react-i18next";
import AddCampaignCode from "./AddCampaignCode";
import UpdateCampaignCode from "./UpdateCampaignCode";

export default function GetAllCampaignCode() {
  const { t } = useTranslation();

  const [pageConfig, setPageConfig] = useState({
    page: 1,
    count: 10,
  });
  const { data, isLoading } = useGetCampaignCodesPaginatedQuery(pageConfig);
  const [edit, setEdit] = useState(null);

  const columns = [
    {
      title: t("common.id"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("campaignCode.name") || "Campaign Code Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "",
      key: "action",
      render: (item) => [
        {
          label: (
            <span className="cursor-pointer" onClick={() => setEdit(item)}>
              <button className="flex justify-center items-center gap-2 rounded">
                <CiEdit /> {t("common.edit")}
              </button>
            </span>
          ),
          key: "edit",
        },
        {
          label: (
            <CommonDelete
              id={item.id}
              title={t("common.delete")}
              permission={"delete-campaignCode"}
              deleteThunk={apiSlice.endpoints.deleteCampaignCode.initiate}
              query={pageConfig}
              className="bg-white text-black"
            />
          ),
          key: "delete",
        },
      ],
    },
  ];

  return (
    <UserPrivateComponent permission={"readAll-campaignCode"}>
      <TableComponent
        list={data?.getAllCampaignCode}
        total={data?.totalCampaignCode}
        columns={columns}
        loading={isLoading}
        setPageConfig={setPageConfig}
        title={t("campaignCode.campaignCodeList") || "Campaign Code List"}
        componentTitle={t("campaignCode.title") || "Campaign Code"}
        extra={
          <CreateDrawer
            permission={"create-campaignCode"}
            title={t("campaignCode.createCampaignCode") || "Create Campaign Code"}
            width={30}>
            <AddCampaignCode />
          </CreateDrawer>
        }
      />
      <Modal
        open={edit}
        onClose={() => setEdit(false)}
        className=" px-5 "
        title={t("campaignCode.editCampaignCode") || "Edit Campaign Code"}>
        <UpdateCampaignCode data={edit} onClose={() => setEdit(false)} />
      </Modal>
    </UserPrivateComponent>
  );
}
